import marketingcloudRotas from './marketingcloud/rotas.js';
import expressoRotas from './expresso/rotas.js';

const routes = {
    path: 'integrape',
    name: 'IntegraPe',
    component: () => import('./IntegraPe.vue'),
    redirect: '/integrape/marketingcloud',
    children: [marketingcloudRotas, expressoRotas],
    meta: {
        rules: [...new Set([...marketingcloudRotas.meta.rules, ...expressoRotas.meta.rules])],
    },
};

export default routes;
